export const FL_RATING_OPTIONS = [
  {
    value: "Pee Wee (L1)",
    label: "Basic",
    level: 1,
  },
  {
    value: "Two Hand Touch (L2)",
    label: "Challenging",
    level: 2,
  },
  {
    value: "Full Contact (L3)",
    label: "Serious",
    level: 3,
  },
  {
    value: "All Pro Elite (L4)",
    label: "Ruthless",
    level: 4,
  },
  {
    value: "No Mercy (L5)",
    label: "Insane",
    level: 5,
  },
];